/* import __COLOCATED_TEMPLATE__ from './schedule-button.hbs'; */
/* RESPONSIBLE TEAM: team-knowledge-foundations */
import Component from '@glimmer/component';
import type ArticleContent from 'embercom/models/articles/article-content';
import { inject as service } from '@ember/service';
import { action } from '@ember/object';
import { tracked } from 'tracked-built-ins';
import { MULTILINGUAL_ARTICLES_FEATURE, ARTICLES_FEATURE } from 'embercom/lib/billing';

interface Signature {
  Element: HTMLElement;
  Args: Args;
}

export interface Args {
  activeContent: ArticleContent;
  scheduleActiveContentUpdate?: (params: { scheduledDate: Date }) => Promise<void>;
  inRightList?: boolean;
  disabled?: boolean;
  isPublishing?: boolean;
  paywallIsActive?: boolean;
}

export default class ScheduleButton extends Component<Signature> {
  @service declare appService: any;

  @tracked showScheduleModal = false;

  get canUseScheduledPublishing() {
    return this.appService.app.canUseScheduledPublishing;
  }

  get paywallConfig() {
    let configs = this.args.activeContent.editorConfig.paywallConfig;
    if (configs) {
      if (!this.args.activeContent.isInDefaultLocale) {
        return configs.find((config) => config.featureKey === MULTILINGUAL_ARTICLES_FEATURE);
      }
      return configs.find((config) => config.featureKey === ARTICLES_FEATURE);
    }
    return undefined;
  }

  isButtonDisabled = (paywallIsActive = false) => {
    return (
      this.args.isPublishing ||
      this.args.activeContent.isPublishDisabled ||
      this.args.disabled ||
      paywallIsActive
    );
  };

  @action async scheduleActiveContentUpdate(params: { scheduledDate: Date }) {
    if (this.args.scheduleActiveContentUpdate) {
      await this.args.scheduleActiveContentUpdate(params);
    }
  }

  @action toggleScheduleModal(state = false): void {
    this.showScheduleModal = state;
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'KnowledgeHub::ContentEditor::ArticleContent::ScheduleButton': typeof ScheduleButton;
    'knowledge-hub/content-editor/article-content/schedule-button': typeof ScheduleButton;
  }
}
